import API from '../../../services/API';

import { setError, startSpinner, stopSpinner } from '../../common/actionCreators';
import { configs } from '../../../constants/configs/configs';
import { PLAN_SUMMARY_ACTION_TYPES } from '../../../constants/actionTypes/planSummaryActionTypes';
import { SPINNER_MESSAGES_IDS } from '../../../constants/common/miscellaneous';

const { PLAN_SUMMARY_GET_PLAN_DETAILS } = configs.endpoints;

export const setPlanSummaryData = (data: any) => ({
    type: PLAN_SUMMARY_ACTION_TYPES.SET_PLAN_DATA,
    payload: data,
});

export const setDataLoading = (isDataLoading: boolean) => ({
    type: PLAN_SUMMARY_ACTION_TYPES.SET_DATA_LOADING,
    payload: isDataLoading,
});

export const setErrorData = (isDataError: boolean) => ({
    type: PLAN_SUMMARY_ACTION_TYPES.SET_DATA_ERROR,
    payload: isDataError,
});

/************************
 # Async action creators
 ************************/
const actions = { setError, startSpinner, stopSpinner };

export const getPlanSummaryData =
    ({ payload }) =>
        async (dispatch: Function) => {
            dispatch(setDataLoading(true));
            dispatch(setErrorData(false));
            const url = PLAN_SUMMARY_GET_PLAN_DETAILS;
            const params = [
                url,
                payload,
                'POST',
                true,
                undefined,
                'application/x-www-form-urlencoded',
                true,
                false,
                false,
                SPINNER_MESSAGES_IDS.LOADING_DATA,
            ];

            const data = await API.postData(params, dispatch, actions);

            if (data) {
                dispatch(setPlanSummaryData({ planSummaryData: data }));
            } else {
                dispatch(setErrorData(true));
            }

            dispatch(setDataLoading(false));
        };
